import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/Marquee";
import { Features } from "@/components/Features";
import { Screenshots } from "@/components/Screenshots";
import { Manifesto } from "@/components/Manifesto";
import { DownloadCTA } from "@/components/DownloadCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <MarqueeStrip />
      <Features />
      <Screenshots />
      <Manifesto />
      <DownloadCTA />
    </main>
  );
}
